import { Link, useNavigate } from "@tanstack/react-router";
import React, { useState, useEffect, useContext } from "react";
import { useAppKitAccount, useDisconnect } from '@reown/appkit/react'
import { AuthContext } from '../../../../lib/auth';
import { sessionStorageGet, sessionStorageRemove } from '../../../../lib/window-shim';
import { useI18n } from '../../../../i18n/context';

/** @module layouts/Head/Navbar/SecNavItem */
function SecNavItem() {
    const { isConnected } = useAppKitAccount();
    const { disconnect } = useDisconnect();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const authContext = React.useContext(AuthContext);
    const { isAuthenticated } = authContext ?? { isAuthenticated: false };
    const navigate = useNavigate();
    const { t } = useI18n();

    useEffect(() => {
        const token = sessionStorageGet('token');
        let hasSessionToken = false;
        if (token) {
            try {
                const userToken = JSON.parse(token);
                if (userToken?.auth === true) {
                    hasSessionToken = true;
                }
            } catch (e) {
                // Ignore invalid token
            }
        }
        setIsLoggedIn(hasSessionToken || isConnected);
    }, [isConnected, isAuthenticated]);

	function signOut(){
		disconnect();
		sessionStorageRemove('token');
        sessionStorageRemove("authKey");
		navigate({ to: '/signin' });
	}

  return (
    <li style={{ display: 'inline-flex', alignItems: 'center' }}>
      {isLoggedIn ? (
        <span onClick={signOut} style={{ color: '#e7eaf1', fontWeight: 760, padding: '8px 10px', borderRadius: '7px', cursor: 'pointer' }}>
          <span style={{ display: 'inline-block', padding: '2px 0', color: '#e7eaf1', fontWeight: 760 }}>{t('nav.signOut')}</span>
        </span>
      ) : (
        <Link to="/signin" className="pixel-nav-link">
          <span style={{ display: 'inline-block', padding: '2px 0', color: '#e7eaf1', fontWeight: 760 }}>{t('nav.signIn')}</span>
        </Link>
      )}
    </li>
  );
}

export default SecNavItem
